<template>

<app-content :loading="is.loading">

	<app-content-body v-if="!is.loading" :is-call="true">

		<app-content-call :loading="is.confirming" icon="approve" theme="green" title="Accept Application" :text="(hasBadges) ? 'The application will be accepted and the user will receive an email notification including a link to complete their badge purchase. You can also optionally include feedback and select which badge types they can purchase.' : 'The application will be accepted and the user will receive an email notification including a link to complete their badge purchase. You can also optionally include feedback.'" :disabled="!model.badges.length" :has-cancel="true" button="Confirm" v-on:click="onConfirmClick" v-on:cancel="onCancelClick">

            <app-input-checklist v-if="hasBadges" v-model="model.badges" :columns="1" :options="$util.options(badges)" class="badges" />

			<app-content-alert v-if="!hasBadges" :is-inline="true" icon="warning" theme="red" :is-slim="true" title="You have not enabled any badge items for the registration block on the associated application page. Please update the page with applicable badge items in order to accept this application." class="badges" />

			<div v-if="suggestions.length" class="suggestions">
				
				<div class="suggestion" v-for="suggestion in suggestions" :key="suggestion.id">

					<div class="suggestion-item is-status"><small>Status</small><span :data-status="$constants.schedule.suggestions.statusTheme[suggestion.status]">{{ $constants.schedule.suggestions.statusName[suggestion.status] }}</span></div>
					<div class="suggestion-item is-name"><small>Name</small>{{ suggestion.name }}</div>

					<template v-if="suggestion.status === $constants.schedule.suggestions.status.approved || suggestion.status === $constants.schedule.suggestions.status.preapproved">
					
						<div class="suggestion-item"><small>Day</small>{{ $con.schedule.days[suggestion.day] }}</div>
						<div class="suggestion-item"><small>Starts</small>{{ $con.schedule.times[suggestion.time] }}</div>
						<div class="suggestion-item"><small>Ends</small>{{ $con.schedule.times[suggestion.time + suggestion.duration] }}</div>

					</template>

				</div>

			</div>

            <app-input-text :autogrow="true" v-model="model.feedback" placeholder="(optional) Enter your feedback..." class="feedback" />

			<app-content-alert v-if="application.linked.total > 1" :is-inline="true" icon="warning" theme="yellow" :is-slim="true" title="This applicant has multiple pending applications.">

				<template v-if="linkedSuggestions.length">There are {{ application.linked.total }} pending applications submitted by this user. By accepting this application the other applications will be archived, but the following game submissions will still be retained and linked to any future registration by the applicant.</template>

				<template v-if="!linkedSuggestions.length">There are {{ application.linked.total }} pending applications submitted by this user. By accepting this application the other applications will be archived.</template>

				<div class="suggestions" v-if="linkedSuggestions.length">

					<div class="suggestion" v-for="suggestion in linkedSuggestions" :key="suggestion.id">

						<div class="suggestion-item is-status"><small>Status</small><span :data-status="$constants.schedule.suggestions.statusTheme[suggestion.status]">{{ $constants.schedule.suggestions.statusName[suggestion.status] }}</span></div>
						<div class="suggestion-item is-name"><small>Name</small>{{ suggestion.name }}</div>

						<template v-if="suggestion.status === $constants.schedule.suggestions.status.approved || suggestion.status === $constants.schedule.suggestions.status.preapproved">
						
							<div class="suggestion-item"><small>Day</small>{{ $con.schedule.days[suggestion.day] }}</div>
							<div class="suggestion-item"><small>Starts</small>{{ $con.schedule.times[suggestion.time] }}</div>
							<div class="suggestion-item"><small>Ends</small>{{ $con.schedule.times[suggestion.time + suggestion.duration] }}</div>

						</template>

					</div>

				</div>

			</app-content-alert>

		</app-content-call>
	
	</app-content-body>

</app-content>

</template>

<script>

import Vue from 'vue'

export default {

	data: function() {

		return {
			is: {
				loading: true,
				confirming: false
			},
            model: {
                feedback: '',
                badges: []
            },
			application: {},
            badges: [],
			suggestions: [],
			linkedSuggestions: []
		}

	},

	created: function() {

		this.load();

	},

    computed: {
    
        hasBadges: function() {
        
            return this.$_.keys(this.badges).length > 1
        
        }

    },

	methods: {

		onCancelClick: function() {

			this.$router.push({
				name: 'Convention.Registration.Applications.Edit'
			})

		},

		onConfirmClick: async function() {

			this.is.confirming = true

			this.$api.post('convention/registration/application/' + this.$route.params.id + '/accept', this.model).then(function() {

				this.$notify({
					message: 'Your feedback has been sent!'
				})

				this.$router.push({
                    name: 'Convention.Registration.Applications.Edit'
				})

            }.bind(this))

		},

		load: function() {

			this.$api.get('convention/registration/application/' + this.$route.params.id + '/accept').then(function(response) {

				Vue.set(this, 'application', response.application)
				Vue.set(this, 'badges', response.badges)
				Vue.set(this, 'suggestions', response.suggestions)
				Vue.set(this, 'linkedSuggestions', response.linkedSuggestions)

                this.model.badges = this.$_.keys(response.badges)

				this.is.loading = false

			}.bind(this), function() {
            
                this.$notify({
					message: 'This is not a pending application.',
					type: 'error'
				})

				this.$router.push({
                    name: 'Convention.Registration.Applications.Edit'
				})
            
            }.bind(this))

		}

	}

}

</script>

<style scoped>

.feedback {
    width: 100%;
    margin-top: 20px;
}

.badges {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
}

.suggestions {
	width: 100%;
}

.alert >>> .suggestions {
	margin-top: 20px;
}

.suggestion {
	display: flex;
	background-color: #fff;
	border: 1px solid #ddd;
	border-top: 0px;
	width: 100%;
}

.alert >>> .suggestion {
	border: 0px;
	margin-top: 1px;
}

.suggestion:first-child {
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
	border-top: 1px solid #ddd;
}

.suggestion:last-child {
	border-bottom-left-radius: 10px;
	border-bottom-right-radius: 10px;
}

.suggestion-item {
	padding: 10px 10px;
	flex-shrink: 0;
	font-weight: 400;
	font-size: 16px;
}

.suggestion-item.is-name {
	flex-grow: 1;
	flex-basis: 0;
}

.suggestion-item.is-status {
	width: 120px;
}

.suggestion-item.is-status span {
	border-radius: 4px;
	font-size: 12px;
	padding: 0px 4px;
	display: inline-block;
	line-height: 20px;
}

.suggestion-item.is-status span[data-status="yellow"] {
	background-color: #ffbe7a;
}

.suggestion-item.is-status span[data-status="red"] {
	background-color: #c55b5b;
	color: #fff;
}

.suggestion-item.is-status span[data-status="green"] {
	background-color: #4faa80;
	color: #fff;
}

.suggestion-item.is-status span[data-status="blue"] {
    background-color: #4082d3;
	color: #fff;
}

.suggestion-item.is-pending {
	text-align: right;
}

.suggestion-item small {
	display: block;
	font-weight: 300;
	font-size: 12px;
	color: #666;
	margin-bottom: 2px;
}

.suggestion.is-empty {
	padding: 20px;
    align-items: center;
    justify-content: center;
    margin: 0px;
    background-color: #dd4848;
    border: 0px;
    color: #fff;
    font-weight: 400;
}

</style>
